import React, { useEffect } from "react";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Services from "@/components/landing/Services";
import WhyChooseUs from "@/components/landing/WhyChooseUs";
import HowItWorks from "@/components/landing/HowItWorks";
import Performance from "@/components/landing/Performance";
import Value from "@/components/landing/Value";
import CalendlyCTA from "@/components/landing/CalendlyCTA";
import Contact from "@/components/landing/Contact";
import FinalCTA from "@/components/landing/FinalCTA";
import Footer from "@/components/landing/Footer";

const Landing = () => {
  useEffect(() => {
    const elements = document.querySelectorAll(".reveal");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    );
    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <main data-testid="landing-page" className="relative bg-[#080808] text-white overflow-x-hidden">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:z-[100] focus:top-4 focus:left-4 focus:bg-[#e8c45a] focus:text-black focus:px-4 focus:py-2 focus:outline-none"
      >
        Skip to main content
      </a>
      {/* Fixed world map canvas - hero only */}
      {/* Phone background for lower sections */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100vh",
          zIndex: 0,
          pointerEvents: "none",
          backgroundImage: "url(/phone-bg.png)",
          backgroundSize: "cover",
          backgroundPosition: "center bottom",
          backgroundRepeat: "no-repeat",
          opacity: 0.5,
        }}
      />

      <div id="main-content" style={{ position: "relative", zIndex: 1 }}>
      <Navbar />
      <Hero />
      <Services />
      <WhyChooseUs />
      <HowItWorks />
      <Performance />
      <Value />
      <CalendlyCTA />
      <Contact />
      <FinalCTA />
      <Footer />
      </div>
    </main>
  );
};

export default Landing;
